module.exports = __webpack_public_path__ + "static/img/icmef.75a066d0.png";